import React, { useEffect, useRef, useState } from 'react';
import { FormGroup, InputGroup, InputGroupAddon, Input as ReactstrapInput } from 'reactstrap';
import cls from 'classnames';
import { FormLabel } from '../FormElements';
import './Input.scss';

const Input = ({
    type = 'text',
    required = false,
    error,
    id,
    name,
    label,
    helpMessage = '',
    className,
    formGroupHidden = false,
    formGroupClassName = '',
    onChange,
    value = '',

    // Input addons
    startAddon = null,
    startAddonContained = true,
    endAddon = null,
    endAddonContained = true,

    // Max length + display
    maxLength,
    displayMaxLength = true,

    // Numeric-only
    wholeNumber = false,
    preventNegative = false,
    ...restProps
}) => {
    const fieldId = id || name;
    const [charCount, setCharCount] = useState(String(value).length);

    const prevDefaultValue = useRef(value);

    useEffect(() => {
        if (value !== prevDefaultValue.current) {
            prevDefaultValue.current = value;
            setCharCount(value.length);
        }
    }, [value]);

    const combinedClass = cls('form-control', className, {
        inputContainedStart: Boolean(startAddon) && !!startAddonContained,
        inputContainedEnd: Boolean(endAddon) && !!endAddonContained,
    });

    const inputProps = {
        name,
        required,
        type,
        value,
        onChange,
        className: combinedClass,
        id: fieldId,
        ...restProps
    };

    return (
        <FormGroup hidden={formGroupHidden} className={cls('form-group-input', formGroupClassName)}>
            {Boolean(label) && (
                <FormLabel htmlFor={fieldId} text={label} required={required} helpMessage={helpMessage} />
            )}

            <div className="form-group-input-container">
                {displayMaxLength && maxLength && (
                    <small className="input-character-label text-muted">
                        {charCount}/{maxLength}
                    </small>
                )}

                {(startAddon || endAddon) ? (
                    <InputGroup className="input-group position-relative">
                        {Boolean(startAddon) && !startAddonContained && (
                            <InputGroupAddon addonType="prepend">
                                {startAddon}
                            </InputGroupAddon>
                        )}

                        <ReactstrapInput {...inputProps} />

                        {Boolean(startAddon) && Boolean(startAddonContained) && (
                            <InputGroupAddon
                                addonType="prepend"
                                className="containedStart"
                            >
                                {startAddon}
                            </InputGroupAddon>
                        )}

                        {Boolean(endAddon) && (
                            <InputGroupAddon
                                addonType="append"
                                className={cls({
                                    containedEnd: endAddonContained,
                                })}
                            >
                                {endAddon}
                            </InputGroupAddon>
                        )}
                    </InputGroup>
                ) : (
                    <ReactstrapInput {...inputProps} />
                )}

                {Boolean(error) && (
                    <small className="invalid-feedback text-danger">
                        {error}
                    </small>
                )}
            </div>
        </FormGroup>
    );
};

export default Input;